import Record from "slotworks/model/gameplay/records/record";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";
import { JackpotTriggertrailResult } from "../../model/results/jackpot-triggertrail-result";
import { AGSResultBuilder } from "./abstract-ags-result-builder";

export class JackpotTriggertrailResultBuilder extends AGSResultBuilder implements ResultBuilder {
    public filter(data: any): boolean {
        const publicState = data as JackpotPublicStateSchema;
        return publicState.jackpots !== undefined;
    }

    public build(record: Record, data: any): Result[] {

        const publicState = data as JackpotPublicStateSchema;

        const jackpotTriggerResult = new JackpotTriggertrailResult();

        jackpotTriggerResult.jackpots = publicState.jackpots;
        jackpotTriggerResult.triggerTrailState = publicState.fireworksState;

        return [jackpotTriggerResult];
    }
}

export default new JackpotTriggertrailResultBuilder();

interface JackpotPublicStateSchema {
    jackpots: number[];
    fireworksState: number;
}
